export default __webpack_public_path__ + "static/media/companyLogo2.a258c7d8.png";